<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    class="bj-label-colon"
    :form="form"
    :rules="rules"
    width="628px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('BusinessLabelHandPage.title') }}</BjDivider>
    <el-row>
      <el-col :span="21">
        <el-form-item :label="$t('BusinessLabelHandPage.labelName')" prop="labelName">
          <BjInput
            v-model="form.labelName"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('inputText')"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="21">
        <el-form-item :label="$t('BusinessLabelHandPage.labelType')" prop="labelType">
          <BjSelectLov
            v-model="form.labelType"
            :disabled="isEdit"
            :option-list="LABEL_SYS_TYPES_STRING"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <BjDivider>{{ $t('BusinessLabelHandPage.labelStyle') }}</BjDivider>
    <el-row>
      <el-col :span="21">
        <el-form-item :label="$t('BusinessLabelHandPage.textContent')" prop="textContent">
          <BjInput
            v-model="form.textContent"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('BusinessLabelHandPage.textContentText')"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="21" class="bj-tag-color-20211104">
        <el-form-item :label="$t('BusinessLabelHandPage.textColor')" prop="textColor">
          <BjRadioLov v-model="form.textColor" :option-list="LABEL_HAND_COLORS">
            <template #default="{ item }">
              <BjTag :color="item.value" class="tag-color" /> </template
          ></BjRadioLov>
        </el-form-item>
      </el-col>

      <el-col :span="21">
        <el-form-item :label="$t('BusinessLabelHandPage.preview')" prop="yulan">
          <BjTag :color="form.textColor" :text="form.textContent" />
        </el-form-item>
      </el-col>
    </el-row>
  </BjDrawerForm>
</template>
<script>
import { LABEL_HAND_COLORS, LABEL_SYS_TYPES } from '@/utils/constants';

const LABEL_SYS_TYPES_STRING = LABEL_SYS_TYPES.map(e => {
  const { label, value } = e;
  return {
    label,
    value: String(value),
  };
});
import { tagsApi } from '@/api';
const getDefaultForm = () => {
  return {
    id: null,

    systemLabelFlag: false,
    changeFlag: true,
    status: true,

    moduleCode: null,

    labelCode: null,
    labelName: null,
    labelType: null,

    textColor: 'orange',
    textContent: null,
  };
};

export default {
  components: {},
  data() {
    return {
      LABEL_HAND_COLORS,
      LABEL_SYS_TYPES_STRING,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        labelCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        labelName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        labelType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        status: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        textContent: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        textColor: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  computed: {},
  watch: {
    // 'form.orderSeq'(v) {
    //   this.form.orderSeq = Number(String(v).replace(/[^0-9]/g, ''));
    // },
  },

  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('BusinessLabelHandPage.editLabel') : this.$t('BusinessLabelHandPage.addLabel'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      tagsApi.addLabels(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      tagsApi.updateLabels(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style>
.bj-tag-color-20211104 .tag-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: absolute;
}
.bj-tag-color-20211104 .el-radio__label {
  padding-right: 20px;
  padding-left: 6px;
}

.bj-tag-color-20211104 .el-radio {
  margin-bottom: 10px;
}
</style>
